module.exports = __webpack_public_path__ + "media/images/admin/icons/calendar-0aa970cf2052f800fc7aecd31246f748.svg";